import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { UncontrolledInput } from './uncontrolled';
import { getCurrencySymbol } from '../../../utils/currency';
import { cn } from '../../../utils';
export const PriceInput = forwardRef(({ currency, className, ...props }, ref) => {
    const currencySymbol = currency ? getCurrencySymbol(currency) : '';
    if (!currency || !currencySymbol) {
        return (_jsx(UncontrolledInput, { ...props, ref: ref, type: "number", className: className }));
    }
    return (_jsxs("div", { className: cn('relative flex rounded-xl border border-gray-100 overflow-hidden', 'focus-within:outline focus-within:outline-2 focus-within:outline-indigo-400 focus-within:outline-offset-2', {
            'border-red-500 focus-within:outline-red-500': props.error,
        }, className), children: [_jsx("div", { className: cn('flex items-center px-3 text-sm text-gray-400 bg-gray-50/50 border-r border-gray-100', {
                    'text-red-300 bg-red-50/30 border-red-200': props.error,
                }), children: currencySymbol }), _jsx("input", { ...props, ref: ref, type: "number", id: props.name, name: props.name, className: cn('flex-1', 'px-3 min-h-12 text-sm text-gray-700', 'placeholder:text-sm placeholder:text-gray-400', '[appearance:textfield]', '[&::-webkit-outer-spin-button]:appearance-none', '[&::-webkit-inner-spin-button]:appearance-none', 'focus:outline-none', 'border-0', {
                    'text-red-500 placeholder:text-red-300': props.error,
                    'cursor-not-allowed': props.disabled,
                }) })] }));
});
PriceInput.displayName = 'PriceInput';
